module.exports = __webpack_public_path__ + "fonts/NanumSquareOTFL.c40969eb.otf";